import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import appStore from './app-store-badge.svg';
import googlePlay from './google-play-badge.svg';

const imgProps = {
  apple: {
    src: appStore,
    alt: 'App Store',
  },
  google: {
    src: googlePlay,
    alt: 'Google Play',
  },
};

function StoreButton({ className, classes, link, brand, sheet, theme, ...other }) {
  const { src, alt } = imgProps[brand];
  return (
    <a
      href={link}
      className={classNames(classes.root, className)}
      target="_blank"
      rel="noopener noreferrer"
      {...other}
    >
      <img src={src} alt={alt} />
    </a>
  );
}

StoreButton.propTypes = {
  brand: PropTypes.oneOf(['apple', 'google']).isRequired,
  link: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  sheet: PropTypes.object,
  theme: PropTypes.object,
};

StoreButton.defaultProps = {
  sheet: null,
  theme: null,
  className: null,
};

const stylesheet = theme => ({
  root: {
    display: 'block',
    height: 50,
    '& img': {
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      '& + &': {
        marginLeft: 3 * theme.spacing.unit,
      },
    },
    [theme.breakpoints.down('md')]: {
      margin: 1.5 * theme.spacing.unit,
    },
  },
});

export default injectSheet(stylesheet)(StoreButton);



// WEBPACK FOOTER //
// ./src/site-render/src/AppSection/StoreButton.js